(function () {
  function getCurrentVariant() {
    var script = document.querySelector('script[data-variant]');
    if (!script) return null;
    try {
      var v = JSON.parse(script.textContent);
      return (v && v.featured_media && v.featured_media.id) ? v : null;
    } catch (e) {
      return null;
    }
  }

  function updateActiveVariantMedia(variant, isInitial) {
    var gallery = document.querySelector('product-gallery');
    if (!gallery || !variant || !variant.featured_media || !variant.featured_media.id) return;

    var mediaId = variant.featured_media.id;
    var media = gallery.querySelector('.product-gallery__carousel [data-media-id="' + mediaId + '"]');
    if (!media) return;

    var allMedia = gallery.querySelectorAll('.product-gallery__carousel .product-gallery__media');
    var thumbList = gallery.querySelector('.product-gallery__thumbnail-list');
    var thumb = thumbList ? thumbList.querySelector('[data-media-id="' + mediaId + '"]') : null;

    allMedia.forEach(function (el) { el.classList.remove('is-active-variant'); });
    if (thumbList) thumbList.querySelectorAll('.scroll-marker').forEach(function (el) { el.classList.remove('is-active-variant'); });

    media.classList.add('is-active-variant');
    if (thumb) thumb.classList.add('is-active-variant');

    /* Force the active variant’s media to load (same as theme preload). Stops “primary media does not load” until swipe. */
    requestAnimationFrame(function () {
      media.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.removeAttribute('loading'); });
      media.querySelectorAll('video[preload="none"]').forEach(function (v) { v.setAttribute('preload', 'metadata'); });
    });

    if (isInitial) return;

    gallery.classList.add('variant-selected');
    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel || typeof carousel.select !== 'function') return;

    if (window.innerWidth >= 1000) {
      carousel.scrollTop = 0;
      carousel.scrollLeft = 0;
    } else {
      var cells = carousel.cells || [];
      var idx = Array.prototype.indexOf.call(cells, media);
      if (idx < 0) idx = 0;
      /* Delay select until after layout (cell was just unhidden). */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          carousel.select(idx, { instant: false });
        });
      });
    }
  }

  function updateRestockDateMessaging() {
    var restockBlocks = document.querySelectorAll('.restock-date[data-product-form-id]');
    if (!restockBlocks.length) return;

    restockBlocks.forEach(function (block) {
      var formId = block.getAttribute('data-product-form-id');
      if (!formId) return;

      var quantityInput = document.querySelector('[name="quantity"][form="' + formId + '"], form#' + formId + ' [name="quantity"]');
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

      var threshold = parseInt(block.getAttribute('data-large-quantity-threshold') || '0', 10);
      if (!Number.isFinite(threshold) || threshold < 1) threshold = 0;

      var defaultMessage = block.getAttribute('data-restock-default-message') || '';
      var largeMessage = block.getAttribute('data-large-quantity-message') || '';
      var conditionMet = threshold > 0 && quantity >= threshold;
      var nextMessage = (conditionMet && largeMessage) ? largeMessage : defaultMessage;

      var messageElement = block.querySelector('[data-restock-message-text]');
      if (messageElement) messageElement.textContent = nextMessage;

      var infoInput = document.querySelector('[data-restock-info-input][form="' + formId + '"]');
      if (infoInput) infoInput.value = nextMessage;
    });
  }

  function bindRestockDateQuantityListeners() {
    var quantityInputs = document.querySelectorAll('form[action*="/cart/add"] [name="quantity"], [name="quantity"][form^="product-form-"]');
    quantityInputs.forEach(function (input) {
      if (input.dataset.restockListenerBound === 'true') return;

      input.dataset.restockListenerBound = 'true';
      input.addEventListener('input', updateRestockDateMessaging);
      input.addEventListener('change', updateRestockDateMessaging);
    });
  }

  // document.addEventListener('DOMContentLoaded', function () {
  //   var priceList = document.querySelector('price-list[data-price-range]') || document.querySelector('price-list');
  //   var variantPrice = document.querySelector('.price-list--variant');
  //   if (priceList && variantPrice && priceList.getAttribute('data-price-range')) {
  //     variantPrice.textContent = priceList.getAttribute('data-price-range');
  //   }
  // });

  document.addEventListener('variant:change', function (e) {
    updateActiveVariantMedia(e.detail.variant, false);
    requestAnimationFrame(function () {
      bindRestockDateQuantityListeners();
      updateRestockDateMessaging();
    });
  });

  document.addEventListener('product:rerender', function () {
    requestAnimationFrame(function () {
      var v = getCurrentVariant();
      if (v) updateActiveVariantMedia(v, true);
      bindRestockDateQuantityListeners();
      updateRestockDateMessaging();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    bindRestockDateQuantityListeners();
    updateRestockDateMessaging();
  });

  /* Lightbox: only show unassigned media + current variant media (same as carousel). */
  document.addEventListener('lightbox:open', function (e) {
    var gallery = (e.target && e.target.closest && e.target.closest('product-gallery')) || document.querySelector('product-gallery');
    if (!gallery || !gallery.carousel) return;

    var cells = gallery.carousel.cells || [];
    var visibleCells = Array.prototype.filter.call(cells, function (c) {
      return !c.hasAttribute('data-variant-id') || c.classList.contains('is-active-variant');
    });
    var images = visibleCells.flatMap(function (cell) {
      return Array.from(cell.querySelectorAll(':scope > img'));
    });
    var dataSource = images.map(function (img) {
      return {
        thumbnailElement: img,
        src: img.src,
        srcset: img.srcset,
        msrc: img.currentSrc || img.src,
        width: parseInt(img.getAttribute('width'), 10),
        height: parseInt(img.getAttribute('height'), 10),
        alt: img.alt,
        thumbCropped: true
      };
    });
    var imageCells = visibleCells.filter(function (c) { return c.getAttribute('data-media-type') === 'image'; });
    var requestedIndex = (e.detail && e.detail.index != null) ? e.detail.index : null;
    var openIndex;
    if (requestedIndex != null && cells[requestedIndex]) {
      openIndex = imageCells.indexOf(cells[requestedIndex]);
    } else {
      openIndex = imageCells.indexOf(gallery.carousel.selectedCell);
    }
    if (openIndex < 0) openIndex = 0;

    e.stopImmediatePropagation();
    gallery.lightBox.loadAndOpen(openIndex, dataSource);
  }, true);
})();
